import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

export function salvarCatalogoUuid() {
  const store = useStore();

  const catalogoUuid = ref(null);

  const verificarUnidadeSalva = async () => {
    if (
      store.state.org.unidadeData.id === "" ||
      store.state.org.unidadeData.id === undefined
    ) {
      salvarUnidade();
      return;
    }
    try {
      const response = await store.dispatch("ferramentaria/listarCatalogo", {
        unidadeId: store.state.org.unidadeData.id,
        page: 1,
        perPage: 10,
      });
      if (response.response.data.resultado?.dados.length == 0) {
        catalogoUuid.value = null;
        store.commit("ferramentaria/SALVAR_CATALOGOUUID", catalogoUuid.value);
        return;
      }
      catalogoUuid.value =
        response.response.data.resultado?.dados[0]?.catalogoUuid;
      store.commit("ferramentaria/SALVAR_CATALOGOUUID", catalogoUuid.value);
    } catch (error) {
      console.log(error);
    }
  };

  const salvarUnidade = async () => {
    try {
      const response = await store.dispatch("requisicao/userLogado");

      if (response.data?.cost_center?.vendor) {
        let unidadeDados = {
          nome: response.data?.cost_center?.vendor.name,
          id: response.data?.cost_center?.vendor.id,
          logo: response.data?.cost_center?.vendor.logo,
          codigoUnidadeIntegracao: "",
        };
        localStorage.unidade = JSON.stringify(unidadeDados);
        store.dispatch("org/saveUnidade", unidadeDados);
      }
    } catch (error) {
      console.log(error);
    }
  };

  watch(
    () => store.state.org.unidadeData.id,
    () => {
      verificarUnidadeSalva();
    }
  );

  onMounted(() => {
    verificarUnidadeSalva();
  });

  return {
    catalogoUuid,
  };
}
